import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { addHandlesToRoutes } from "./addHandlesToRoutes";
import { LinkProvider } from "./routerProvider";
import baseRoutes from "./routes";
import { RouterLinksInterface } from "./types";
import { useState } from "react";
import { useAuthorizedRoutes } from "authorization/useAuthorizedRoutes";

const Router = () => {
  const routes = useAuthorizedRoutes(baseRoutes());
  const routerLinks: RouterLinksInterface = {};
  const addHandles = addHandlesToRoutes(routerLinks);

  const { processedRoutes } = addHandles({ routes });

  // Get the basename from the package.json homepage or environment
  const getBasename = () => {
    const basePath = window.APP_CONFIG?.api?.basePath ?? "";
    return basePath ? `/${basePath.replace(/^\/+/, "")}`.replace(/\/+$/, "") : "";
  };

  // Create router instance once using useState initializer to prevent recreation on re-renders.
  // Using useState ensures the router persists across all re-renders after auth completes.
  const [router] = useState(() =>
    createBrowserRouter(processedRoutes, {
      basename: getBasename(),
    })
  );
  return (
    <LinkProvider value={routerLinks}>
      <RouterProvider router={router} fallbackElement="sada" />
    </LinkProvider>
  );
};
export default Router;
